var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComunicacionDirectaConTuRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 157.832,
    height: 137.611,
    viewBox: "0 0 157.832 137.611",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px;stroke-dasharray:1 12;}.a,.b{stroke:#f0f4f9;stroke-miterlimit:10;}.b{fill:#fdfffc;stroke-width:2px;}.c{fill:#7821a0;}.d{fill:url(#a);}.e{fill:#a4c2f7;}.f{fill:#e8edfc;}.g{fill:#cad9fc;}.h{fill:#efd2ff;}.i{fill:#fff;}.j{fill:#264ecc;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -0.672,
    y1: -3.759,
    x2: -0.669,
    y2: -3.765,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#dae2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201,
    stopColor: "#ebeaf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201,
    stopColor: "#f6eff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    stopColor: "#fdf2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#dae2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421,
    stopColor: "#ebeaf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421,
    stopColor: "#f6eff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#fdf2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f8f0f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#e7e8f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#dce3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#d5e0f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851,
    stopColor: "#d3dff2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 2.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 66.306,
    cy: 66.306,
    r: 66.306,
    transform: "translate(21.721)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 44.585)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 21.721,
    cy: 21.721,
    r: 21.721
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M7.434,13.718a1.43,1.43,0,0,1-1.1-.473L.447,7.2A1.524,1.524,0,0,1,.5,5a1.524,1.524,0,0,1,2.206.052L7.487,9.988,17.574.427a1.561,1.561,0,1,1,2.154,2.259L8.538,13.3A1.806,1.806,0,0,1,7.434,13.718Z",
    transform: "translate(11.432 14.862)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.027 -879.211)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.626 908.483)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M98.045,969.489v9.054H51.434v-22a16.377,16.377,0,0,0,5.71,1.025h14.1a1.165,1.165,0,0,0,1.165-1.165v-4.661H77.07v2.447a16.032,16.032,0,0,0,15.662,16.2A15.435,15.435,0,0,0,98.045,969.489Z",
    transform: "translate(-39.781 -924.941)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M121.025,981.178v8.263h3.5v-9.054A15.24,15.24,0,0,1,121.025,981.178Z",
    transform: "translate(-66.257 -935.838)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M60.674,1003.157H42.03L47.856,995H94.467l5.826,8.156H60.674Z",
    transform: "translate(-36.203 -941.398)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M124.521,995h-3.5l5.826,8.156h3.5Z",
    transform: "translate(-66.257 -941.398)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M60.674,1008.166H42.03v3.5a3.5,3.5,0,0,0,3.5,3.5H96.8a3.5,3.5,0,0,0,3.5-3.5v-3.5Z",
    transform: "translate(-36.203 -946.407)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M128.282,1008.166v3.5a3.5,3.5,0,0,1-3.5,3.5h3.5a3.5,3.5,0,0,0,3.5-3.5v-3.5Z",
    transform: "translate(-67.688 -946.407)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M82.611,1008.35h8.156l2.331-2.331-1.165-3.5H73.288l-1.165,3.5,2.331,2.331Z",
    transform: "translate(-47.652 -944.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M65.968,926.561v14.1a1.165,1.165,0,0,1-1.165,1.165H50.7a16.377,16.377,0,0,1-5.71-1.025,15.658,15.658,0,0,1,5.314-30.437A15.387,15.387,0,0,1,60.479,914.3a16.43,16.43,0,0,1,5.489,12.259Z",
    transform: "translate(-33.34 -909.198)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M69.055,914.3a15.387,15.387,0,0,0-10.172-3.938,15.828,15.828,0,0,0-1.838.108,15.433,15.433,0,0,1,8.515,3.83,16.432,16.432,0,0,1,5.489,12.259v14.1a1.165,1.165,0,0,1-1.165,1.165h3.5a1.165,1.165,0,0,0,1.165-1.165v-14.1A16.43,16.43,0,0,0,69.055,914.3Z",
    transform: "translate(-41.916 -909.199)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M124.274,946.714a15.739,15.739,0,0,1-10.487,14.9,15.435,15.435,0,0,1-5.313.9,16.032,16.032,0,0,1-15.662-16.2v-14.1a1.165,1.165,0,0,1,1.165-1.165h14.1a16.032,16.032,0,0,1,16.2,15.661Z",
    transform: "translate(-55.523 -917.069)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M115.3,931.052h-3.5a16.032,16.032,0,0,1,16.2,15.661,15.739,15.739,0,0,1-10.487,14.9,15.327,15.327,0,0,1-3.511.794,15.576,15.576,0,0,0,7.007-.794,15.739,15.739,0,0,0,10.487-14.9A16.031,16.031,0,0,0,115.3,931.052Z",
    transform: "translate(-62.751 -917.069)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.574,
    cy: 7.574,
    r: 7.574,
    transform: "translate(9.322 8.157)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.574,
    cy: 7.574,
    r: 7.574,
    transform: "translate(45.446 20.975)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M117.13,942.338a7.556,7.556,0,0,0-1.748.211,7.566,7.566,0,0,1,0,14.727,7.574,7.574,0,1,0,1.748-14.937Z",
    transform: "translate(-64.11 -921.363)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M122.026,970.054V971.3a15.909,15.909,0,0,1-4.661,2.61,15.429,15.429,0,0,1-15.149-2.75v-1.1a7.085,7.085,0,0,1,4.662-6.689,7.587,7.587,0,0,0,10.511-.012A7.067,7.067,0,0,1,122.026,970.054Z",
    transform: "translate(-59.101 -929.362)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M122.411,963.365a7.708,7.708,0,0,1-1.515,1.121,7.108,7.108,0,0,1,2.657,5.567V971.3a15.909,15.909,0,0,1-4.661,2.61,15.256,15.256,0,0,1-3.474.789,15.207,15.207,0,0,0,6.969-.789,15.909,15.909,0,0,0,4.661-2.61v-1.247a7.067,7.067,0,0,0-4.637-6.689Z",
    transform: "translate(-64.124 -929.362)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M63.721,949.37v4.743H54.282a16.483,16.483,0,0,1-10.371-3.682v-1.072a7.094,7.094,0,0,1,4.638-6.7,7.574,7.574,0,0,0,10.511.023,7.073,7.073,0,0,1,4.661,6.689Z",
    transform: "translate(-36.919 -921.485)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M39.168,970.958v3.5a3.5,3.5,0,0,0,3.5,3.5h3.5a3.5,3.5,0,0,1-3.5-3.5v-3.5L48.49,962.8v-22a16.1,16.1,0,0,1-4.661-2.665c-11-8.928-5.373-26.266,8.139-27.669a15.341,15.341,0,0,0-1.66-.1c-14.822-.061-21.463,18.448-9.975,27.772a16.1,16.1,0,0,0,4.661,2.665v22Z",
    transform: "translate(-33.341 -909.198)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M49.554,979.954h2.33v9.323h-2.33Z",
    transform: "translate(-39.066 -935.674)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M50.719,975.4a1.165,1.165,0,0,0,1.165-1.165v-8.157a1.165,1.165,0,0,0-2.33,0v8.157A1.165,1.165,0,0,0,50.719,975.4Z",
    transform: "translate(-39.066 -929.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M50.753,987.927a1.165,1.165,0,1,1-.012-2.33h.012a1.165,1.165,0,1,1,0,2.33Z",
    transform: "translate(-39.077 -937.821)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M93.752,985.6a1.165,1.165,0,0,0-1.165,1.165v3.5H47.141a1.247,1.247,0,0,0-.949.488c-6.16,8.717-6,8.135-6.043,8.834v3.5a4.661,4.661,0,0,0,4.662,4.661H96.082a4.661,4.661,0,0,0,4.661-4.661v-3.5c-.116-.953-.062-.186-5.826-8.531v-4.287A1.165,1.165,0,0,0,93.752,985.6Zm4.661,17.479a2.331,2.331,0,0,1-2.33,2.331H44.811a2.331,2.331,0,0,1-2.331-2.331v-2.331h17l1.989,1.989a1.165,1.165,0,0,0,.824.341H78.6a1.164,1.164,0,0,0,.824-.341l1.989-1.989h17Zm-27.966-2.331H62.772l-1.48-1.479.672-2.016H78.928l.672,2.016-1.479,1.479Zm11.327-2.33-.9-2.7a1.165,1.165,0,0,0-1.106-.8H61.124a1.165,1.165,0,0,0-1.106.8l-.9,2.7H43.579l4.162-5.826h45.41l4.163,5.826Z",
    transform: "translate(-35.488 -937.821)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M60.54,912.715A16.64,16.64,0,0,0,49.6,908.483h-.074a16.89,16.89,0,0,0-16.9,16.971,17.166,17.166,0,0,0,17.362,16.822h14.1a2.331,2.331,0,0,0,2.331-2.331v-14.1A17.582,17.582,0,0,0,60.54,912.715ZM46.609,939.56v-1.945a1.165,1.165,0,1,0-2.331,0v1.23a15.1,15.1,0,0,1-3.5-1.981v-.508a5.958,5.958,0,0,1,3.273-5.333,8.7,8.7,0,0,0,10.908.019,5.926,5.926,0,0,1,3.3,5.326v3.577h-3.5v-2.33a1.165,1.165,0,1,0-2.331,0v2.33H49.988A15.478,15.478,0,0,1,46.609,939.56Zm2.913-8.937a6.409,6.409,0,1,1,6.409-6.409A6.409,6.409,0,0,1,49.522,930.623Zm14.566,9.322h-3.5v-3.577a8.274,8.274,0,0,0-3.975-7.071,8.739,8.739,0,1,0-14.2-.02,8.283,8.283,0,0,0-3.81,5.581,14.216,14.216,0,0,1-3.647-9.414,14.565,14.565,0,0,1,14.566-14.631h.061a14.3,14.3,0,0,1,9.4,3.644,15.244,15.244,0,0,1,5.1,11.388Z",
    transform: "translate(-32.626 -908.483)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M107.362,929.171h-14.1a2.33,2.33,0,0,0-2.33,2.331v14.1a17.328,17.328,0,0,0,12.351,16.705c.022.009.048.01.07.019a16.36,16.36,0,0,0,4.405.639h.069A16.889,16.889,0,0,0,124.724,946,17.168,17.168,0,0,0,107.362,929.171Zm.4,31.462a14.052,14.052,0,0,1-2.852-.305V958.3a1.165,1.165,0,1,0-2.33,0v1.3a14.42,14.42,0,0,1-3.5-2.012v-.538a5.926,5.926,0,0,1,3.3-5.326,8.7,8.7,0,0,0,10.908-.019,5.959,5.959,0,0,1,3.274,5.333v.661a14.4,14.4,0,0,1-3.5,1.948V958.3a1.165,1.165,0,1,0-2.331,0v2.039a14.744,14.744,0,0,1-2.913.291Zm.061-9.322a6.409,6.409,0,1,1,6.41-6.409,6.409,6.409,0,0,1-6.41,6.409Zm10.953,4.345a8.291,8.291,0,0,0-3.844-5.691,8.739,8.739,0,1,0-14.206.02,8.249,8.249,0,0,0-3.816,5.534,15.228,15.228,0,0,1-3.652-9.917V931.5h14.1a14.833,14.833,0,0,1,15.032,14.505,14.445,14.445,0,0,1-3.613,9.65Z",
    transform: "translate(-54.808 -916.353)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M82.25,972.444a17.456,17.456,0,0,1-2.523.174,18.463,18.463,0,0,1-13.191-5.477,1.166,1.166,0,1,0-1.654,1.643,20.776,20.776,0,0,0,14.845,6.164,19.84,19.84,0,0,0,2.862-.2,1.165,1.165,0,0,0-.339-2.305Z",
    transform: "translate(-44.769 -930.668)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M100.685,920.4a1.165,1.165,0,0,0,.826-1.981,20.773,20.773,0,0,0-14.844-6.176,20.2,20.2,0,0,0-2.883.2,1.166,1.166,0,1,0,.334,2.307,17.808,17.808,0,0,1,2.549-.175,18.462,18.462,0,0,1,13.191,5.483A1.164,1.164,0,0,0,100.685,920.4Z",
    transform: "translate(-51.709 -909.914)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComunicacionDirectaConTuRed);
export default __webpack_public_path__ + "static/media/comunicacion_directa_con_tu_red.e3d3f316b91cb8d1c5c2128477852b06.svg";
export { ForwardRef as ReactComponent };